// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__Vz53p","link":"styles_link__1jmD0","separator":"styles_separator__2NQ0W"};